import { useQuery } from '@tanstack/react-query';

import type { ExtractionSource, ExtractionSourceRecordType } from '@optiro/types';

import useApi from '@/hooks/useApi/useApi';
import { queryKeys } from '@/lib/queryKeys';

/** The Kilde of the given records of a project, by record id. Only records an udtræk wrote have one. */
export const useExtractionSources = (
  projectId: string | number | null | undefined,
  recordType: ExtractionSourceRecordType,
  ids: number[]
) => {
  const { axiosInstance } = useApi();

  return useQuery<Record<string, ExtractionSource>>({
    queryKey: queryKeys.fileExtractions.sources(projectId ?? undefined, recordType, ids).queryKey,
    queryFn: async () => {
      const { data } = await axiosInstance.get<Record<string, ExtractionSource>>(
        `/api/v1/projects/${projectId}/extraction_sources`,
        { params: { record_type: recordType, ids } }
      );
      return data;
    },
    enabled: !!projectId && ids.length > 0,
  });
};
